import { useQuery } from '@tanstack/react-query'
import { useApiClientAmbassador } from '~/@api/client/useApiClientAmbassador'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

export type CodeCheckResult =
  | { available: true }
  | { available: false; message: string }

/**
 * Checks whether an ambassador code is available.
 * 200 => the code is free; 400 => the code is taken/invalid (we surface the
 * backend message). Other failures (401/network/5xx) reject the query so they
 * are NOT mistaken for "code taken".
 */
export function useAmbassadorCodeCheck(code: string) {
  const api = useApiClientAmbassador()
  const trimmedCode = code.trim()

  return useQuery<CodeCheckResult>({
    queryKey: ['ambassador-code-check', trimmedCode],
    enabled: trimmedCode.length > 0,
    retry: false,
    queryFn: async () => {
      try {
        await api.user.ambassadorControllerPostAmbassadorCodeCheck(
          { code: trimmedCode },
          { secure: true }
        )
        return { available: true }
      } catch (error) {
        if (error != null && (error as Response).status === 400) {
          return {
            available: false,
            message: getApiErrorMessage(
              error,
              'Tento kód nie je možné použiť.'
            ),
          }
        }
        throw error
      }
    },
  })
}
